import React from "react";
import MintCard from "../MintCard";
import preview from "../../../../assets/images/preview.svg";

const NftPreview = ({
  loader,
  input,
  previewLink,
  pieData,
  colors,
  preset,
  widget,
  data
}) => {
  const card = {
    id: 0,
    image: (previewLink)
      ? `${previewLink}`
      : preview,
    name: input.name
      ? `${input.name.approved_name} #${input.name.display_order}`
      : "",
    address: "",
    forsell: input.forsale ? input.forsale : false,
    buy: false,
    price: input.background ? input.background.price ? input.background.price : 0 : "",
    distPresetName: preset ? preset : "",
    pieData: 
      pieData.length > 0
        ? 
          [
            { value: Math.round(pieData[0]), color: colors.beneficiary_color },
            { value: Math.round(pieData[1]), color: colors.artist_color },
            { value: Math.round(pieData[2]), color: colors.sponsor_color },
            /*{ value: Math.round(pieData[3]), color: colors.seller_color },*/
          ]
        : []
    
  };

  const renderContent = () => {
    if (loader)
      return (
        <div className="card">
          <div className="card-loader card-loader--tabs"></div>
        </div>
      );
    return <MintCard card={card} />;
  };

  return (
    <React.Fragment>
      <h3
        className={widget === "final" ? "mint-preview__title final" : "mint-preview__title"}
        style={{ color: data.web_main_color}}
      >
        {card.name ? card.name : data.nft_name === "" || data.nft_name === null ? "My New NFT" : `My New ${data.nft_name}`}
      </h3>
      <div className={widget === "final" ? "mint-card final" : "mint-card"}>{renderContent()}</div>
    </React.Fragment>
  );
};

export default React.memo(NftPreview);
